<div id="content-wrapper" class="container">
	<div class="row align-items-center justify-content-center" style="height:calc(100vh - 166px);">
		<div class="col-auto">

			<div class="card shadow">
				<h5 class="card-header">Fiók regisztráció</h5>
				<div class="card-body container-fluid" style="width:500px; max-width:calc(100vw - 40px);">
					<%- include('/ui/form', {
						params: [ 'register', register_form_data, { width: 360 } ],
						fields: [
							{ type: 'row', fields: [
								{ type: 'col', fields: [
									{
										type: 'text',
										name: 'account_name',
										title: 'Fiók név',
										attributes: { autocomplete: 'no' }
									},
									{
										type: 'text',
										name: 'contact_email',
										title: 'E-mail cím',
										attributes: { autocomplete: 'new-password' }
									},
									{
										type: 'text',
										variant: 'password',
										name: 'password',
										title: 'Jelszó',
										append: `<button type="button" class="btn btn-outline-secondary" onmousedown="$('#register_password')[0].type = 'text'" onmouseup="$('#register_password')[0].type = 'password'"><i class="fa fa-eye"></i></button>`,
										help: 'A választott jelszónak tartalmaznia kell <strong>kisbetűt, nagybetűt, számot</strong> és <strong>legalább 8 karakter</strong> hosszúnak kell lennie.',
										attributes: { autocomplete: 'new-password' }
									},
									{
										type: 'text',
										variant: 'password',
										name: 'password_confirm',
										title: 'Jelszó megerősítése'
									},
								]}
							]}
						]
					}) %>
				</div>
				<div class="card-footer">
					<a href="/login" class="btn btn-light"><i class="fa fa-arrow-left me-2"></i>Vissza</a>
					<button type="button" onclick="Anvil.page.register()" class="btn btn-primary float-end"><i class="fa fa-id-badge me-2"></i>Regisztráció</button>
				</div>
			</div>

		</div>
	</div>
</div>

<script>
Object.assign(Anvil.page, {

	register: async function () {
		Anvil.exec('auth/action_register')
	}
})
</script>
